import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { initialFormValues, warehouseSchema, type WarehouseFormValues } from '../schemas';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { InfoTab, InventoryTab } from './tabs';
import { FormMode } from '@/types/form';
import { cn } from '@/lib/utils';

interface FormDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: Partial<WarehouseFormValues>;
  activeTab?: string;
  onTabChange?: (value: string) => void;
  onClose: () => void;
  onSubmit: (data: WarehouseFormValues) => void | Promise<void>;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  zIndex?: number;
}

const getDialogTitle = (mode: FormMode) => {
  if (mode === 'add') return 'Thêm mới kho hàng';
  if (mode === 'edit') return 'Sửa kho hàng';
  return 'Xem chi tiết kho hàng';
};

export default function FormDialog({
  open,
  mode,
  initialData,
  activeTab = 'thong tin',
  onTabChange,
  onClose,
  onSubmit,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  zIndex
}: FormDialogProps) {
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={getDialogTitle(mode)}
      maxWidth='lg'
      titleIcon={<AritoIcon icon={281} />}
      paperClassName='w-[min(980px,calc(100vw-16px))]'
      zIndex={zIndex}
    >
      <AritoFormV2
        mode={mode}
        hasAritoActionBar={false}
        schema={warehouseSchema}
        initialData={initialData || initialFormValues}
        onSubmit={onSubmit}
        className='w-full min-w-0 max-w-full'
        headerFields={
          <>
            {mode === 'view' && (
              <>
                <Tabs value={activeTab} onValueChange={onTabChange} className='w-full'>
                  <TabsList className='h-8 justify-start rounded-none border-b border-gray-200 bg-transparent p-0'>
                    <TabsTrigger
                      value='thong tin'
                      className='h-8 rounded-none border-b-2 border-transparent px-3 py-0 text-xs font-normal normal-case text-gray-600 shadow-none data-[state=active]:border-[#023e8a] data-[state=active]:bg-[#f0f5fa] data-[state=active]:text-[#023e8a] data-[state=active]:shadow-none'
                    >
                      Thông tin
                    </TabsTrigger>
                    <TabsTrigger
                      value='ton kho'
                      className='h-8 rounded-none border-b-2 border-transparent px-3 py-0 text-xs font-normal normal-case text-gray-600 shadow-none data-[state=active]:border-[#023e8a] data-[state=active]:bg-[#f0f5fa] data-[state=active]:text-[#023e8a] data-[state=active]:shadow-none'
                    >
                      Tồn kho
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
                <div className='min-h-0 w-full min-w-0'>
                  <div className={cn(activeTab === 'thong tin' ? 'block' : 'hidden')}>
                    <InfoTab mode={mode} />
                  </div>
                  <div className={cn(activeTab === 'ton kho' ? 'block' : 'hidden')}>
                    <InventoryTab />
                  </div>
                </div>
              </>
            )}

            {mode !== 'view' && <InfoTab mode={mode} />}
          </>
        }
        bottomBar={
          <BottomActionBarV2
            mode={mode}
            onClose={onClose}
            onAdd={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}
            onCopy={onCopy}
          />
        }
      />
    </DialogV2>
  );
}
